
import React, { useState, useEffect, useContext,useRef  } from 'react';
import { addBusinessDays } from 'date-fns';
import Select from 'react-select';
import { useNavigate, useLocation } from 'react-router-dom';
import { Audio } from 'react-loader-spinner';
import { MdOutlineCancel } from 'react-icons/md';

import { TiCancel } from "react-icons/ti";
import { Layout, Header } from '../../../../components';
import { handleApi, formatCurrency, inputDate,formatTwoDecimal,formatMediumDate } from '../../../../utils/utils';
import AppContext from '../../../../contexts/AppContext';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
//import ApproveOrder from './ApproveOrder00';

const CancelInvoice= () => {
  const location = useLocation();
  const { inv } = location.state || {};
  const [isLoading, setIsLoading] = useState(false);
    const [selectedReason, setSelectedReason] = useState(null);
  const invoiceNoInputRef = useRef(null);
  const [showCancelButton, setShowCancelButton] = useState(true);
  const { userData, currentColor, actionCount, setActionCount } = useContext(AppContext);
  const navigate = useNavigate();
  const handleClose = () => { navigate(-1)};  // Navigate back when closing the form
  console.log('invoice sir',inv)
  
    
    const  calculateDueDate=(startDate) =>{
        return addBusinessDays(startDate, 30).toISOString().split('T')[0];
    }
    const today = new Date().toISOString().split('T')[0];
    
    const [invoice, setInvoice] = useState({
      date: inv?.date || today,
      due_date: inv?.due_date || today, // Calculate based on today's date
      state: inv?.state || 'draft',
      order_id: inv?.order_id || 0,
      invoice_no: inv?.invoice_no || '',
    });

        

  // Timeout helper for API calls
        const handleApiWithTimeout = async (url, invoice, userData, method, parameters, timeout = 5000) => {
          const controller = new AbortController();
          const timeoutId = setTimeout(() => controller.abort(), timeout);
      
          try {
            const response = await handleApi(url, invoice, userData, method, parameters, { signal: controller.signal });
            return response;
          } catch (error) {
            if (error.name === 'AbortError') {
              toast.error('Request timed out');
            } else {
              toast.error('Error: ' + error.message);
            }
            throw error;
          } finally {
            clearTimeout(timeoutId);
          }
        };
     

  
        const handleSubmit = async () => {
            console.log('ready for submission sir ', invoice);
          
            // Check if a reason is selected
            if (!selectedReason) {
              toast.error('Please select a cancellation reason');
              return;
            }
          
            // Create the cleaned invoice object with cancellation details
            const cleanedInvoice = {
              id: invoice.id,
              state: 'cancelled', // Update state to 'cancelled' if you're canceling
              cancellation_reason: selectedReason.value, // Use the selected reason value
              cancellation_date: new Date().toISOString().split('T')[0], // Use today's date in YYYY-MM-DD format
            };
          
            const apiEndpoint = 'purchase/invoices';
            const apiMethod = 'PUT';
            const parameters = {};
          
            setIsLoading(true); // Start loading
            try {
              const response = await handleApiWithTimeout(apiEndpoint, cleanedInvoice, userData, apiMethod, parameters);
              console.log("API Response:", response);  // Log the API response to see if we are getting the expected data
              if (response.status === 200) {
                toast.success('Purchase Invoice cancelled successfully.');
                setShowCancelButton(false); // Hide cancel button after success
              } else {
                toast.error('Error cancelling purchase invoice.', response.statusText);
              }
            } catch (error) {
              console.error("API Error:", error);  // Log any error that might occur
              toast.error('Error cancelling purchase Invoice: ' + error.message);
            } finally {
              setIsLoading(false); // Always stop loading after request is done
              setActionCount(actionCount + 1); // Update action count
            }
          };
        
  
  const TransactionLineHeader = () => {
    return (
      <div className="grid grid-cols-6 gap-4 p-2 border-b rounded-lg w-full bg-gray-50 text-gray-800 font-semibold text-xs">
        <div className="col-span-2 text-left">Product</div>
        <div className="col-span-1 text-center">Price</div>
        <div className="col-span-1 text-center">Qty</div>
        <div className="col-span-1 text-center">Disc %</div>
        <div className="col-span-1 text-right">Total</div>
      </div>
    );
  };

//   console.log('transaction lines sir',order.transactionLines)
 
  return (
    
    <Layout>
        <div className="m-4 bg-black rounded-xl shadow-2xl p-1">
          <ToastContainer position="top-center" autoClose={2000} />
          <div className="text-center py-4 border-b">
            <div className="w-full flex justify-end">
              <button
                className="text-white hover:text-gray-300 py-1 px-2 rounded transition-all duration-300"
                title="Close"
                onClick={handleClose}
              >
                <MdOutlineCancel size={24} color={currentColor}/>
              </button>
            </div>      
            <div className="mx-4 text-white">
              <Header category="Purchase" title="Cancel Invoice" color={currentColor}/>
            </div>
          </div>        
    
          {/* Loading State */}
          {isLoading ? (
            <div className="flex flex-col items-center py-6">
              <Audio height="80" width="80" color="white" ariaLabel="loading" />
              <p className="mt-4 text-white">Processing payment...</p>
            </div>
          ) : (
            <div className="bg-white p-2 my-2 rounded-xl shadow-2xl">
                {showCancelButton && (
                    <div className="flex justify-end p-2 bg-gray-100 rounded-xl">
                        <button
                            onClick={handleSubmit}
                            className="text-white px-3 py-2 font-bold rounded-lg flex bg-red-500 hover:bg-red-700 transition-all duration-300 transform hover:scale-105"
                        >
                            < TiCancel size={25} />
                            <span>CANCEL</span>
                        </button>
                                 
                    </div>
                )}
                
                {/* all information */}
                <div className=" my-4   mx-auto grid grid-cols-1 md:grid-cols-2 gap-6">
                {/* Order information */}
                <div className=" bg-gray-50 px-2 rounded-lg shadow-md text-gray-800">
                    <p className="text-lg text-center font-bold mb-2">INVOICE INFO</p>
                    <div className="space-y-1">
                    <div className="flex justify-between text-sm">
                        <label className="font-medium">Invoice No.:</label>
                        <span className='font-bold'>{inv?.invoice_no || 'N/A'}</span>
                    </div>
                    <div className="flex justify-between text-sm">
                        <label className="font-medium">Invoice Date:</label>
                        <span>{formatMediumDate(inv?.date)}</span>
                    </div>
                    <div className="flex justify-between text-sm">
                        <label className="font-medium">Due Date:</label>
                        <span>{formatMediumDate(inv?.due_date)}</span>
                    </div>
        
        <div className="flex justify-between text-sm">
            <label className="font-medium">Invoice Status:</label>

                      <span className={`text-sm text-white py-1  rounded-full uppercase font-bold
                      ${inv?.state?.toLowerCase() === 'draft' ? 'text-yellow-700' :
                        inv?.state?.toLowerCase() === 'approved' ? 'text-blue-300' :
                        inv?.state?.toLowerCase() === 'paid' ? 'text-green-700' :
                        inv?.state?.toLowerCase() === 'deleted' ? 'text-gray-400' :
                        inv?.state?.toLowerCase() === 'partially_paid' ? 'text-green-400' :
                        inv?.state?.toLowerCase() === 'awaiting_payment_approval' ? 'text-yellow-700' :
                        inv?.state?.toLowerCase() === 'payment_approved' ? 'text-blue-700' :
                        inv?.state?.toLowerCase() === 'cancelled' ? 'text-red-600' : 'text-yellow-500'}`}>
                      {inv?.state}
                    </span>
                    </div>
                  </div>
                </div>

                {/* End order Info Section */}

                {/* supplier Information Section */}
                <div className="bg-gray-50 p-2 rounded-lg shadow-md text-gray-800 text-xs">
                  <p className="text-lg text-center font-bold mb-2 uppercase">Order info</p>
                  <div className="space-y-1">
                    <div className="flex justify-between text-sm">
                      <label className="font-medium">Order No:</label>
                      <span>{inv?.p_orders.reference || 'N/A'}</span>
                    </div>
                    <div className="flex justify-between text-sm">
                      <label className="font-medium">Order Date:</label>
                      <span>{formatMediumDate(inv?.p_orders.date) || 'N/A'}</span>
                    
                    </div>
                    <div className="flex justify-between text-sm">
                        <label className="font-medium">Product Delivery:</label>
                        <span className={`font-bold uppercase ${inv?.p_orders.delivered === 'yes' ? 'text-green-600' : 'text-yellow-700'}`}>
                            {inv?.p_orders.delivered === 'yes' ? 'Delivered' : 'Not delivered'}
                        </span>
                    </div>
                    
                  </div>
                </div>
                {/* end supplier  Info Section */}
                
                {/* Order detail  Section */}
                <div className="bg-gray-50 p-2 rounded-lg shadow-md text-gray-800 t">
                  {/* order info */}
                  <p className="text-lg text-center font-bold mb-2 uppercase ">supllier info</p>
                  <div className="space-y-1">
                    <div className="flex justify-between text-sm">
                      <label className="font-medium">Supplier Name:</label>
                      <span>{inv?.partners?.name || 'N/A'}</span>
                    </div>
                    <div className="flex justify-between text-sm">
                      <label className="font-medium">Contact Person:</label>
                      <span>{inv?.partners?.contact_person || 'N/A'}</span>
                    </div>
                    <div className="flex justify-between text-sm">
                      <label className="font-medium">Phone:</label>
                      <span>{inv?.partners?.phone_number || 'N/A'}</span>
                    </div>
                    <div className="flex justify-between text-sm">
                      <label className="font-medium">Email:</label>
                      <span>{inv?.partners?.email || 'N/A'}</span>
                    </div>
                    
                    {/* end Transation Lines*/}
                  </div>
                 
                  
                </div>
                {/* End order detail   Section */}
                {/* Invoice  information */}
                <div className="bg-gray-50 p-2 rounded-lg shadow-md text-gray-800">
                  <p className="text-lg text-center font-bold mb-2">ORDER DETAIL </p>
                <div>
                    {/* Transaction lines */}
                    <div className="bg-white rounded-lg shadow-md text-xs">
                        {(inv?.order?.transactionLines || []).length > 0 ? (
                        <>
                          <TransactionLineHeader />
                          {inv?.order.transactionLines.map((line, index) => (
                            <div
                              key={index}
                              className={`grid grid-cols-6 p-1 border-b hover:bg-gray-50 ${index === inv?.order.transactionLines.length - 1 ? 'border-b' : ''}`}
                            >
                              <div className="col-span-2 text-gray-700">{line.description || ''}</div>
                              <div className="col-span-1 text-center text-gray-600">{formatTwoDecimal(line.unit_price) || ''}</div>
                              <div className="col-span-1 text-center text-gray-600">{line.quantity || ''}</div>
                              <div className="col-span-1 text-center text-gray-600">{line.discount_percentage || 0}</div>
                              <div className="col-span-1 text-right text-gray-600">{formatTwoDecimal(line.lineDiscountedPriceInclusive) || ''}</div> 
                            </div>
                          ))}
                        </>
                      ) : (
                        <p className="p-6 text-center text-gray-500">No transactions found. Please ensure the selected order has transactions.</p>
                      )}
                    </div>
                    {inv?.order?.transactionLines?.length > 0 && (
  <div className="mt-2 space-y-1 p-1 rounded-lg shadow-md text-xs">
    <div className="flex justify-between text-xs">
      <span>Subtotal:</span>
      <span className='font-bold'>{inv?.order?.totalPriceExclusive}</span>
    </div>
    <div className="flex justify-between text-xs">
      <span>Discount:</span>
      <span>{inv?.order?.totalDiscountExclusive}</span>
    </div>

    <div className="flex justify-between text-xs">
      <span>Subtotal After Discount:</span>
      <span className='font-bold'>{inv?.order?.totalDiscountedPriceExclusive}</span>
    </div>

    <div className="flex justify-between text-xs">
      <span>Tax:</span>
      <span>{inv?.order?.totalTaxAfterDiscounted}</span>
    </div>

    <div className="flex justify-between text-xs">
      <span>Grand Total:</span>
      <span className='font-bold'>{inv?.order?.totalDiscountedPriceInclusive}</span>
    </div>
  </div>
)}



                </div>

                
                

                    
                </div>
                {/* End Invoice SInformation Section */}
                {/* supplier information */}
                
                
              </div>
                
                {/* end all information */}
    
             
    
             
    
              {/* Action Buttons */}
              <div className="flex justify-end space-x-4 mt-4">
              
                <button
                  onClick={handleClose}
                  className="bg-blue-500 text-white px-4 py-2 rounded-lg hover:bg-blue-700 flex items-center gap-2"
                >
                  <MdOutlineCancel size={20} />
                  <span>Close</span>
                </button>
              </div>    
          </div>
      )}
    </div>
    </Layout>
   
    
  );
};
export default CancelInvoice;
